// All sales related apis
import instance, { API_URL } from "./api";
import { encryptData } from "../helpers/encryptDecrypt";

// Post api for creating a new sale for active organization and branch
export const saveSale = async (saleData) => {
  return await instance.post(`${API_URL}/sales`, saleData, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(saleData),
  });
};

// Get api for fetching sales data for the active organization and branch with filters and pagination options
export const fetchSalesByOrganizationAndBranch = async (
  organizationId,
  branchId,
  filter_type,
  payment_type,
  start_date,
  end_date,
  search_keyword,
  page,
  limit,
  type
) => {
  const oId = encryptData(organizationId);
  const bId = encryptData(branchId);

  return await instance.get(
    `${API_URL}/sales/filtered?organizationId=${oId}&branchId=${bId}&filter_type=${filter_type}&payment_type=${payment_type}&start_date=${start_date}&end_date=${end_date}&keyword=${search_keyword}&page=${page}&limit=${limit}&type=${type}`
  );
};

// Get api for fetching sales summary for the active organization and branch with filters and pagination options
export const fetchSalesSummaryByOrganizationAndBranch = async (
  organizationId,
  branchId,
  filter_type,
  payment_type,
  start_date,
  end_date,
  uId,
  type
) => {
  const oId = encryptData(organizationId);
  const bId = encryptData(branchId);

  return await instance.get(
    `${API_URL}/sales/revenue-summary?organizationId=${oId}&branchId=${bId}&filter_type=${filter_type}&payment_type=${payment_type}&start_date=${start_date}&end_date=${end_date}&uId=${uId}&isOrder=&type=${type}`
  );
};

// Get api for fetching sales to download for the active organization and branch with filters and pagination options
export const fetchSalesToDownloadByOrganizationAndBranch = async (
  organizationId,
  branchId,
  filter_type,
  payment_type,
  start_date,
  end_date,
  uId,
  type
) => {
  const oId = encryptData(organizationId);
  const bId = encryptData(branchId);

  return await instance.get(
    `${API_URL}/sales/download?organizationId=${oId}&branchId=${bId}&filter_type=${filter_type}&payment_type=${payment_type}&start_date=${start_date}&end_date=${end_date}&uId=${uId}&isOrder=&type=${type}`
  );
};

// Get api for fetching sales data for the selected user with filters and pagination options
export const fetchSalesByUser = async (
  userId,
  organizationId,
  branchId,
  filter_type,
  payment_type,
  start_date,
  end_date,
  search_keyword,
  page,
  limit,
  type
) => {
  const oId = encryptData(organizationId);
  const bId = encryptData(branchId);
  const uId = encryptData(userId);

  return await instance.get(
    `${API_URL}/sales/by-user/${uId}?organizationId=${oId}&branchId=${bId}&filter_type=${filter_type}&payment_type=${payment_type}&start_date=${start_date}&end_date=${end_date}&keyword=${search_keyword}&page=${page}&limit=${limit}&type=${type}`
  );
};

// Delete api for soft deleting/canceling the existing sale
export const deleteSale = async (saleId) => {
  const sId = encryptData(saleId);

  return await instance.delete(`${API_URL}/sales/${sId}`);
};

// Post api for fetching sale's Invoice
export const fetchSaleInvoice = async (saleId, organizationId) => {
  const sId = encryptData(saleId);
  const oId = encryptData(organizationId);
  return await instance.post(`${API_URL}/sales/invoice/${sId}/${oId}`);
};

// Post api for returning the existing sale's products
export const returnSaleItems = async (saleId, data) => {
  const sId = encryptData(saleId);
  return await instance.post(`${API_URL}/sales/return/${sId}`, data);
};

// Post api for linking customer to the sale's data
export const insertCustomerToSale = async (saleId, data) => {
  const sId = encryptData(saleId);
  return await instance.post(`${API_URL}/sales/customer/${sId}`, data);
};

// Get api for getting sales details by id
export const fetchSaleDetails = async (saleId, branchId) => {
  const sId = encryptData(saleId);
  const bId = encryptData(branchId);
  return await instance.get(`${API_URL}/sales/${bId}/${sId}`);
};

export const fetchSalePdf = async (saleId) => {
  return await instance.get(`${API_URL}/sales/download-pdf/${saleId}`, {
    responseType: "blob",
  });
};
